import findIndex from 'lodash/findIndex'
import investments from '@/api/investments'

export default () => ({
  namespaced: true,

  state: {
    search: {
      investments: [],
      meta: {}
    },
    contractId: null,
    query: '',
    limit: 10,
    page: 1,
    basket: [],
    tags: []
  },

  actions: {
    search (context, { contractId, recommendedRisk, query, limit = 10, page = 1, cached = true }) {
      const { state } = context
      if (cached && state.search.length && contractId === state.contractId &&
        query === state.query && limit === state.limit && page === state.page) {
        return Promise.resolve(state.search)
      }

      return investments.fetch(contractId, recommendedRisk, query, undefined, limit, page)
        .then(data => {
          context.commit('search', { data, contractId, query, limit, page })
        })
    },
    fetchAndAddByIsin (context, { funds, basketFrom }) {
      if (!Array.isArray(funds)) {
        funds = [funds]
      }
      const basket = []
      return Promise.all(
        funds.map(fund => investments.fetchByIsin(fund.isin)
          .then(
            fullFund => basket.push({
              ...fullFund,
              basketFrom
            }),
            () => basket.push({
              general: { ...fund },
              basketFrom
            })
          ))
      )
        .then(() => context.commit('addToBasket', basket))
    },
    fetchAndAddByTag (context, { contractId, recommendedRisk, tagId }) {
      return investments.fetch(contractId, recommendedRisk, undefined, tagId, 1)
        .then(funds => {
          if (funds.investments.length) {
            context.dispatch('fetchAndAddByIsin', { funds: funds.investments, basketFrom: `tag-${tagId}` })
          }
        })
    },
    fetchTags ({ commit, state }, cached = true) {
      if (cached && state.tags.length) {
        return Promise.resolve(state.tags)
      }
      return investments.fetchTags()
        .then(response => {
          commit('fetchTags', response.data)
        })
    }
  },

  mutations: {
    search (state, { data, contractId, query, limit, page }) {
      state.search = data
      state.contractId = contractId
      state.query = query
      state.limit = limit
      state.page = page
    },
    fetchTags (state, data) {
      state.tags = data
    },
    resetBasket (state) {
      state.basket = []
    },
    addToBasket (state, funds) {
      state.basket = [
        ...state.basket,
        ...(Array.isArray(funds) ? funds : [funds]).filter(fund => !state.basket.find(item => item.general.isin === fund.general.isin))
      ]
    },
    removeTagFromBasket (state, tagId) {
      const fundIndex = findIndex(state.basket, { basketFrom: `tag-${tagId}` })
      if (fundIndex >= 0) {
        state.basket = [
          ...state.basket.slice(0, fundIndex),
          ...state.basket.slice(fundIndex + 1)
        ]
      }
    },
    removeFromBasket (state, funds) {
      if (!Array.isArray(funds)) {
        funds = [funds]
      }
      for (const fund of funds) {
        const index = findIndex(state.basket, item => item.general.isin === fund.general.isin)
        if (index >= 0) {
          state.basket = [
            ...state.basket.slice(0, index),
            ...state.basket.slice(index + 1)
          ]
        }
      }
    }
  },

  getters: {
  }
})
